<template>
  <van-popup v-model="showRules" class="rule-popup" :overlay-style="{ background: 'rgba(0,0,0,.7)' }">
    <div class="content-container">
      <div class="content">
        <p v-html="ruleText" style="padding-left: 0"></p>
      </div>
      <img class="close" @click="showRules = false" src="@/static/images/activityCenter/202404/01/close.png" />
    </div>
  </van-popup>
</template>

<script>
export default {
  props: {
    ruleText: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      showRules: false
    };
  },

  methods: {
    open() {
      this.showRules = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.van-popup {
  background: transparent !important;
  padding-bottom: 120px;
}
.content-container {
  position: relative;
  width: 660px;
  padding: 14px 15px 28px 15px;
  background: linear-gradient(44deg, #ef3805 0%, #ffab3b 100%);
  border-radius: 45px;
  border: 2px solid #ffd93e;
  .content {
    padding: 0px 38px 46px 38px;
    background: linear-gradient(37deg, #fff5e2 0%, #ffffff 100%);
    box-shadow: 0px 0px 14px #de4700;
    border-radius: 36px;
    border: 3px solid #ffd195;
    max-height: 1080px;
    overflow-y: scroll;
    p {
      font-size: 26px;
      color: #643d2e;
      padding-left: 42px;
      margin-top: 10px;
      margin-bottom: 30px;
    }
    /deep/table {
      border-collapse: collapse;
      td {
        border: 1px solid #643d2e;
      }
    }
  }
  .close {
    position: absolute;
    width: 66px;
    height: 66px;
    bottom: -120px;
    left: 50%;
    margin-left: -33px;
  }
}
</style>
